import React from "react";
import { FaFacebookMessenger } from "react-icons/fa";

import ChannelConnectCard from "../ChannelConnect/ChannelConnectCard";

/**
 * Messenger: the bot answers on the Facebook Pages this account administers.
 * Same login and same endpoint as Instagram, different scopes and branding.
 */
const messenger = {
  name: "Messenger",
  // Sent with the token so the server knows which channel was connected.
  key: "messenger",
  title: "Connect Messenger",
  subtitle: "Let your store answer Facebook Page messages around the clock.",
  logo: FaFacebookMessenger,
  gradient: "linear(135deg, #00B2FF 0%, #006AFF 55%, #A033FF 100%)",
  markColor: "#0084FF",
  accentColor: "#0084FF",
  storePath: "/admin/bots/messenger",
  storageKeys: { user: "fbUser", connected: "fbAccountConnected" },
  scope: [
    "public_profile",
    "pages_messaging",
    "pages_show_list",
    "pages_manage_metadata",
    "business_management",
  ].join(","),
  /** Nothing can be answered without it. */
  requiredScopes: ["pages_messaging"],
  capabilities: [
    "Show a persistent menu in every Page conversation",
    "Answer buyers automatically with your AI assistant",
    "Send order and shipping updates to customers",
  ],
  note:
    "You need to be an administrator of the Facebook Page you want the bot to answer on.",
};

const ConnectToFacebook = () => <ChannelConnectCard channel={messenger} />;

export default ConnectToFacebook;
